import { CustomerType } from '@modules/ticket-fares-store';
import { CustomerTypeIds } from '@nx-ng/types';
import { isNullOrUndefined } from './isNullOrUndefined';

export function parseCustomerTypeId(
  maybeCustomerType: string | undefined
): CustomerTypeIds | undefined {
  if (isNullOrUndefined(maybeCustomerType) || maybeCustomerType === '') {
    return undefined;
  }

  const validCustomerIds = Object.values(CustomerTypeIds) as CustomerTypeIds[];

  const parsedNumber = Number(maybeCustomerType);

  return !Number.isNaN(parsedNumber) && validCustomerIds.includes(parsedNumber)
    ? parsedNumber
    : undefined;
}
